export default __webpack_public_path__ + "static/media/expl_13_EN.77a20256.png";